module.exports = __webpack_public_path__ + "img/horizontal-stairs.743f6b52.png";